<div>
  <div fxLayoutAlign="end">
    <a (click)="close()" matTooltip="Fermer la fenêtre" style="cursor: pointer;"><mat-icon>close</mat-icon></a>
  </div>
  <div>
    <img [src]="file" [height]="height"/>
  </div>
  <div fxLayoutAlign="end">
    <a (click)="download()" matTooltip="Télécharger l'image" style="cursor: pointer;"><mat-icon>file_download</mat-icon></a>
  </div>
</div>
